module.exports = __webpack_public_path__ + "static/media/tr808_rimshot.9a20640a.wav";